/**
 * PhoneButton
 * 
 * @Author: Focci
 * @Date: 2023-08-08 10:23:01
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-08 10:23:01
 */

'use client'

import PropTypes from 'prop-types'
import useTracking from '@hook/useTracking'
import PhoneTrigger from '@comp/PhoneTrigger'
import { houseToGta, isAU } from '@lib/utils'
import { useCallback } from 'react'

export default function PhoneButton({
  agentId,
  phone,
  trackParams,
  house,
  ...props
}) {
  const { pushTrack, pushTrackListing } = useTracking()
  const handleClick = useCallback(() => {
    house && pushTrackListing('click_phone', house)
    pushTrack('click_phone', { ...trackParams, agentId })

    if (house && isAU) {
      pushTrack('homely_phone_enquiry', houseToGta(house))
    }
  }, [pushTrackListing, house, pushTrack, trackParams, agentId])

  return (
    <PhoneTrigger 
      phoneNumber={phone}
      onChange={handleClick}
      {...props}
    />
  )
}

PhoneButton.propTypes = {
  // agentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  phone: PropTypes.string,
  house: PropTypes.object,
}
